import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'simple-checkbox',
    templateUrl: './simple-checkbox.component.html',
    styleUrls: ['./simple-checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SimpleCheckboxComponent {
  @Input() name: string;
  @Input() label: string;
  @Input() checked: boolean | null;
  @Input() disabled: boolean | null = null;

  @Output() checkedChange: EventEmitter<Event> = new EventEmitter<Event>();

  onChange($event: Event) {
    this.checkedChange.emit($event);
  }
}
